import React, { useRef } from 'react';
import { flushSync } from 'react-dom';
import classnames from 'classnames';
import { DOTS, usePaginationRange } from './usePaginationRange';
import { Info } from './Info';
import { PerPageDropdown } from './PerPageDropdown';
import { NavigationBlock } from './NavigationBlock';
import { Dots } from './Dots';
import { PageButton } from './PageButton';
export var Pagination = function (_a) {
    var className = _a.className, _b = _a.locale, locale = _b === void 0 ? 'nb' : _b, _c = _a.showRowsPerPageText, showRowsPerPageText = _c === void 0 ? true : _c, paginationControls = _a.paginationControls, rowsPerPageOptions = _a.rowsPerPageOptions, _d = _a.navigationButtonText, navigationButtonText = _d === void 0 ? true : _d, ariaLabel = _a.ariaLabel, onClickPrev = _a.onClickPrev, onClickNext = _a.onClickNext, onClickPage = _a.onClickPage;
    var firstPageButton = useRef(null);
    var lastPageButton = useRef(null);
    var pageNumberList = usePaginationRange(paginationControls.totalElements, paginationControls.currentPageSize, paginationControls.currentPage);
    return (React.createElement("div", { role: "group", "aria-label": ariaLabel, className: classnames('ffe-pagination', className) },
        React.createElement("div", { className: "ffe-pagination__rows" },
            showRowsPerPageText && (React.createElement(Info, { className: "ffe-pagination__rows-item", locale: locale, start: paginationControls.pageStart + 1, end: paginationControls.pageEnd, total: paginationControls.totalElements })),
            !!(rowsPerPageOptions === null || rowsPerPageOptions === void 0 ? void 0 : rowsPerPageOptions.length) && (React.createElement(PerPageDropdown, { className: "ffe-pagination__rows-item", locale: locale, rowsPerPageOptions: rowsPerPageOptions, setPageSize: paginationControls.setPageSize, defaultValue: paginationControls.currentPageSize }))),
        pageNumberList && pageNumberList.length > 1 && (React.createElement("nav", { className: "ffe-pagination__buttons" },
            React.createElement(NavigationBlock, { className: "ffe-pagination__buttons-nav", locale: locale, onClick: function () {
                    onClickPrev === null || onClickPrev === void 0 ? void 0 : onClickPrev();
                    var prevPage = Math.max(paginationControls.currentPage - 1, 1);
                    flushSync(function () {
                        var _a;
                        paginationControls.setCurrentPage(prevPage);
                        var isGoingToFirstPage = prevPage === 1;
                        if (isGoingToFirstPage) {
                            (_a = firstPageButton.current) === null || _a === void 0 ? void 0 : _a.focus({
                                preventScroll: true,
                            });
                        }
                    });
                }, isHidden: !paginationControls.hasPreviousPage, buttonText: navigationButtonText, direction: "prev" }),
            React.createElement("ol", { className: "ffe-pagination__page-buttons" }, pageNumberList.map(function (pageNumber, index) {
                return (React.createElement("li", { key: index }, pageNumber === DOTS ? (React.createElement(Dots, null)) : (React.createElement(PageButton, { ref: index === 0
                        ? firstPageButton
                        : index ===
                            pageNumberList.length -
                                1
                            ? lastPageButton
                            : null, key: index, locale: locale, onClick: function () {
                        onClickPage === null || onClickPage === void 0 ? void 0 : onClickPage(pageNumber);
                        paginationControls.setCurrentPage(pageNumber);
                    }, isActive: paginationControls.currentPage ===
                        pageNumber }, pageNumber))));
            })),
            React.createElement(NavigationBlock, { className: "ffe-pagination__buttons-nav", locale: locale, onClick: function () {
                    onClickNext === null || onClickNext === void 0 ? void 0 : onClickNext();
                    var nextPage = Math.min(paginationControls.currentPage + 1, paginationControls.numberOfPages);
                    flushSync(function () {
                        var _a;
                        paginationControls.setCurrentPage(nextPage);
                        var isGoingToLastPage = paginationControls.numberOfPages ===
                            nextPage;
                        if (isGoingToLastPage) {
                            (_a = lastPageButton.current) === null || _a === void 0 ? void 0 : _a.focus({
                                preventScroll: true,
                            });
                        }
                    });
                }, isHidden: !paginationControls.hasNextPage, buttonText: navigationButtonText, direction: "next" })))));
};
